var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"color":"red accent-2","dark":""},on:{"click":_vm.Backbutton}},[_vm._v(" Back ")]),_c('iframe',{attrs:{"src":_vm.pdfpath,"width":"100%","height":"1000px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }